/* eslint-disable indent */
import Image from "next/image";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";
import { HeroCharacter, HeroLandscape, HeroMonster } from "@/images";
// Move showcase items outside component to prevent recreation
const showcaseItems = [{
  title: "Elf Paladin",
  desc: "Create legendary characters",
  src: HeroCharacter
}, {
  title: "Legendary Beholder",
  desc: "Generate Monsters with ease",
  src: HeroMonster
}, {
  title: "Mirabar",
  desc: "Craft captivating landscapes in seconds",
  src: HeroLandscape
}];
export default function LandingHero() {
  const isMobile = useIsMobile();
  return <div className="bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-slate-100 overflow-x-hidden" data-sentry-component="LandingHero" data-sentry-source-file="LandingHero.tsx">
            <main className="flex-1">
                <section className="relative pt-36 pb-28 md:pt-40 md:pb-32 overflow-hidden">
                    <div className="container mx-auto px-4 sm:px-6">
                        <div className="max-w-4xl mx-auto text-center mb-16">
                            <h1 className="text-[clamp(2.5rem,6vw,4.5rem)] font-extrabold leading-tight mb-6 bg-gradient-to-r from-blue-400 via-cyan-400 to-emerald-500 bg-clip-text text-transparent">
                                Instant AI Generated Art for Your RPGs
                            </h1>
                            <p className="text-[clamp(1rem,2.5vw,1.25rem)] text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed">
                                Create stunning character art for your RPGs in
                                seconds. No prompting expertise required.
                            </p>
                            <div className="flex flex-col sm:flex-row justify-center gap-5 mb-16">
                                <Link href="/generate" prefetch={false} title="Get Started For Free" data-sentry-element="Link" data-sentry-source-file="LandingHero.tsx">
                                    <Button size="lg" className="!px-8 !py-3 text-lg bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white shadow-lg shadow-emerald-900/30 rounded-xl transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-emerald-700/40" data-sentry-element="Button" data-sentry-source-file="LandingHero.tsx">
                                        🔥 Get Started For Free
                                    </Button>
                                </Link>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
                            {showcaseItems.map((item, index) => <div key={index} className="group relative aspect-[3/4] overflow-hidden rounded-xl shadow-xl shadow-slate-900/30 transform transition-all duration-300 ease-in-out hover:scale-[1.03] hover:shadow-slate-700/40">
                                    <div className="absolute inset-0 rounded-xl ring-1 ring-inset ring-slate-800/50 group-hover:ring-sky-500/40 transition-shadow duration-300"></div>
                                    <Image src={item.src} alt={item.title} fill loading={index === 0 || !isMobile ? "eager" : "lazy"} priority={index === 0} sizes={index === 0 ? "(max-width: 767px) calc(100vw - 2rem), 33vw" : isMobile ? "calc(100vw - 2rem)" : "33vw"} className="object-cover transition-transform duration-500 ease-in-out group-hover:scale-110" quality={80} placeholder="blur" blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAAE0lEQVR42mNMy0t9ZSBhAAL8APE9XQcSAPsFAAAAAElFTkSuQmCC" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-300" />
                                    <div className="absolute bottom-0 left-0 right-0 p-5">
                                        <p className="text-lg font-semibold text-white drop-shadow-md">
                                            {item.title}
                                        </p>
                                        <p className="text-sm text-slate-200/90 drop-shadow-sm mt-1">
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>)}
                        </div>
                    </div>
                </section>
            </main>
        </div>;
}